import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import Footer from '../components/Footer';

const NotFoundPage = () => {
  useEffect(() => {
    document.title = 'Page Not Found | IP9';
  }, []);

  return (
    <div className="min-h-screen bg-slate-950 flex flex-col">
      <Header />
      <main className="relative flex-1 overflow-hidden border-b border-slate-800">
        <div className="absolute inset-0 bg-grid bg-grid-fade" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 md:py-36">
          <p className="font-mono text-[11px] uppercase tracking-[0.18em] text-cyan-400 mb-6">Error 404 · Route not found</p>
          <h1 className="font-display text-[5rem] md:text-[9rem] leading-none font-bold text-slate-50 mb-6">
            4<span className="text-cyan-500">0</span>4
          </h1>
          <p className="text-lg text-slate-400 max-w-xl mb-10">This page has no exit node. It may have moved, or the link may be wrong.</p>
          <div className="flex flex-wrap gap-3">
            <Link to="/" className="inline-flex items-center h-11 px-6 bg-cyan-500 hover:bg-cyan-400 text-slate-950 font-semibold transition-colors">
              Back to home
            </Link>
            <Link to="/docs" className="inline-flex items-center h-11 px-6 border border-slate-600 hover:border-slate-300 text-slate-200 transition-colors">
              Documentation
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default NotFoundPage;
